<template>
  <v-list dense>
    <template v-for="item in items">
      <v-list-item
        :key="item.name"
        v-if="(item.hideChildrenInMenu || !item.children) && !item.hidden"
        link
        :to="item.path"
      >
        <v-list-item-icon>
          <v-icon v-text="item.meta.icon" />
        </v-list-item-icon>

        <v-list-item-title class="title-sidebar">{{
          $t(item.meta.title)
        }}</v-list-item-title>
      </v-list-item>

      <v-list-group
        :prepend-icon="item.meta.icon ? item.meta.icon : ''"
        :key="item.name"
        no-action
        v-else-if="(!item.hideChildrenInMenu || item.children) && !item.hidden"
      >
        <template v-slot:activator>
          <v-list-item-title class="title-sidebar" :to="item.path">
            {{
            $t(item.meta.title)
          }}</v-list-item-title>
        </template>
        <template v-for="itemInChildren in item.children">
          <v-list-item
            :key="itemInChildren.name"
            v-if="!itemInChildren.hidden"
            link
            :to="itemInChildren.path"
          >
            <v-list-item-title class="title-sidebar">{{
              $t(itemInChildren.meta.title)
            }}</v-list-item-title>
            <v-list-item-icon v-if="itemInChildren.meta.icon">
              <v-icon v-text="itemInChildren.meta.icon" />
            </v-list-item-icon>
          </v-list-item>
        </template>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    items: {
      type: Array,
    },
  },
  mounted() {
    console.log("items: ", this.items);
  },
};
</script>

<style scoped>
.v-list-item--link:before {
  background-color: white;
}

.v-list .v-list-item--active {
  color: #42b983;
}
.item-title {
  line-height: 1.5rem !important;
}
.title-sidebar {
  font-size: 1rem !important;
  font-weight: 600 !important;
  line-height: 2rem;
  letter-spacing: 0.0125em !important;
  font-family: "Roboto", sans-serif !important;
}
</style>